import { Pipe, PipeTransform } from "@angular/core";
import { FileTypeService } from "../services/file-type.service";

@Pipe({ name: 'fileTypeIcon' })
export class FileTypeIconPipe implements PipeTransform {

    constructor(private fileTypeService: FileTypeService ) {
    }

    transform(fileExtension: string): string {
        return this.fileTypeService.getFileTypeIcon(fileExtension);
    }
   
}